import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {
	className?: string;
}
const PrevIcon: React.FC<IProps> = (props) => {
	return (
		<svg
			width="51"
			height="50"
			viewBox="0 0 51 50"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<rect x="0.289551" width="50" height="50" rx="25" fill="white" />
			<path
				d="M29.2896 16L21.2896 25L29.2896 34"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default memo(PrevIcon);
